/**
 * NotificationIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const NotificationIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m21.798 17.4-2.8-3.73V9.5a6.5 6.5 0 0 0-5.5-6.41V2a1 1 0 1 0-2 0v1.09a6.5 6.5 0 0 0-5.5 6.41v4.17l-2.8 3.73a1 1 0 0 0 .8 1.6h4.5a4 4 0 0 0 8 0h4.5a1 1 0 0 0 .8-1.6m-9.3 3.6a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2m-6.5-4 1.8-2.4a1 1 0 0 0 .2-.6V9.5a4.5 4.5 0 1 1 9 0V14a1 1 0 0 0 .2.6l1.8 2.4z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const NotificationIcon = makeIcon('NotificationIcon', NotificationIconSvg)
